<template>
  <div class="flex flex-col">
    <pt-view-table
      :data="data"
      :columns="columns"
      :row-class="classes.row"
      :header-class="classes.header"
      :column-class="classes.column"
      :tbody-class="classes.tbody"
      :thead-class="classes.thead"
      class="promo-table border mb-8"
    />
  </div>
</template>
<script>
import { PtViewTable } from '@pathao/ui-components/esm/Table';
import formatSchedule from '@utils/format-schedule';

let parentThis;
const columns = [
  {
    header: 'Saturday',
    component: {
      props: ['rowData'],
      methods: {
        schedules() {
          return this.rowData.saturday || [];
        },
        getTime(schedule) {
          return parentThis.timeFilter(schedule.opening_time) + '-' + parentThis.timeFilter(schedule.closing_time);
        },
      },
      render() {
        return (
          <span class="schedule-list-td">
            { this.schedules().map(schedule => <span class="line-item capitalize text-center mb-1">{ this.getTime(schedule) }</span>) }
          </span>
        );
      },
    },
  },
  {
    header: 'Sunday',
    component: {
      props: ['rowData'],
      methods: {
        schedules() {
          return this.rowData.sunday || [];
        },
        getTime(schedule) {
          return parentThis.timeFilter(schedule.opening_time) + '-' + parentThis.timeFilter(schedule.closing_time);
        },
      },
      render() {
        return (
          <span class="schedule-list-td">
            { this.schedules().map(schedule => <span class='line-item capitalize text-center mb-1'>{this.getTime(schedule)}</span>) }
          </span>
        );
      },
    },
  },
  {
    header: 'Monday',
    component: {
      props: ['rowData'],
      methods: {
        schedules() {
          return this.rowData.monday || [];
        },
        getTime(schedule) {
          return parentThis.timeFilter(schedule.opening_time) + '-' + parentThis.timeFilter(schedule.closing_time);
        },
      },
      render() {
        return (
          <span class="schedule-list-td">
            { this.schedules().map(schedule => <span class='line-item capitalize text-center mb-1'>{this.getTime(schedule)}</span>) }
          </span>
        );
      },
    },
  },
  {
    header: 'Tuesday',
    component: {
      props: ['rowData'],
      methods: {
        schedules() {
          return this.rowData.tuesday || [];
        },
        getTime(schedule) {
          return parentThis.timeFilter(schedule.opening_time) + '-' + parentThis.timeFilter(schedule.closing_time);
        },
      },
      render() {
        return (
          <span class="schedule-list-td">
            { this.schedules().map(schedule => <span class='line-item capitalize text-center mb-1'>{this.getTime(schedule)}</span>) }
          </span>
        );
      },
    },
  },
  {
    header: 'Wednesday',
    component: {
      props: ['rowData'],
      methods: {
        schedules() {
          return this.rowData.wednesday || [];
        },
        getTime(schedule) {
          return parentThis.timeFilter(schedule.opening_time) + '-' + parentThis.timeFilter(schedule.closing_time);
        },
      },
      render() {
        return (
          <span class="schedule-list-td">
            { this.schedules().map(schedule => <span class='line-item capitalize text-center mb-1'>{this.getTime(schedule)}</span>) }
          </span>
        );
      },
    },
  },
  {
    header: 'Thursday',
    component: {
      props: ['rowData'],
      methods: {
        schedules() {
          return this.rowData.thursday || [];
        },
        getTime(schedule) {
          return parentThis.timeFilter(schedule.opening_time) + '-' + parentThis.timeFilter(schedule.closing_time);
        },
      },
      render() {
        return (
          <span class="schedule-list-td">
            { this.schedules().map(schedule => <span class='line-item capitalize text-center mb-1'>{this.getTime(schedule)}</span>) }
          </span>
        );
      },
    },
  },
  {
    header: 'Friday',
    component: {
      props: ['rowData'],
      methods: {
        schedules() {
          return this.rowData.friday || [];
        },
        getTime(schedule) {
          return parentThis.timeFilter(schedule.opening_time) + '-' + parentThis.timeFilter(schedule.closing_time);
        },
      },
      render() {
        return (
          <span class="schedule-list-td">
            { this.schedules().map(schedule => <span class='line-item capitalize text-center mb-1'>{this.getTime(schedule)}</span>) }
          </span>
        );
      },
    },
  },
];
export default {
  name: 'ScheduleList',
  components: {
    PtViewTable,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      columns,
      data: [],
      classes: {
        thead: 'bg-grey-lighter w-full text-left md:hidden-thead',
        tbody: 'bg-white text-center',
        row: 'border-b-4 lg:border-b border-solid border-grey-light mb-0 w-full',
        column: 'p-4 border-b lg:border-r lg:border-b-0',
        header: 'py-4',
      },
    };
  },
  watch: {
    list(newVal, oldVal) {
      this.data = formatSchedule(newVal);
    },
  },
  mounted() {
    parentThis = this;
    this.data = formatSchedule(this.list);
  },
  methods: {
    timeFilter(value) {
      let [hours, minutes] = value.split(':');
      let period = 'AM';
      let hour = parseInt(hours);
      if (hour === 0) {
        hour = 12;
      } else if (hour >= 12) {
        period = 'PM';
        if (hour > 12) {
          hour -= 12;
        }
      }
      return `${hour}:${minutes} ${period}`;
    },
  },
};
</script>
